module.exports = __webpack_public_path__ + "static/client-mutual-96269190c285b5fcc4a4d5ae0d9ea0c6.png";